import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { RequestService, RequestDesign } from "../services/request.service";

@Injectable()
export class RequestDesignResolver implements Resolve<RequestDesign> {
  constructor(private requestService: RequestService) {
  }
  resolve(route: ActivatedRouteSnapshot): Observable<RequestDesign> {
    const id: number = route.params['id'];
    return this.requestService.getDesign(id);
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/resolvers/request-design.resolver.ts